import { Injectable } from '@angular/core';

import { ApiDataType } from '../../../../types';
import { UnitResult } from '../../../error';
import { LaravelApiError } from './laravel-error-mapper.service';

@Injectable({ providedIn: 'root' })
export class DavidResponseProcessor {
    processResponse<T>(response: ApiDataType): UnitResult<T> {
        const apiResponse = response as ApiDataType;

        if (apiResponse.success) {
            const data = apiResponse.data as unknown as T;
            return UnitResult.success<T>(data);
        }

        const error: LaravelApiError = {
            success: false,
            message: 'Unable to process request',
            errors: response.error
        };
        throw {
            status: 500,
            error: error
        };
    }
}
